const HAS_TIMEZONE = /Z|[+-]\d{2}:\d{2}$/

/**
 * Viewing pickers represent Dubai wall time. Existing ISO values are already an
 * instant and therefore retain their suffix instead of being interpreted again.
 */
export const viewingDateToUTC = (value: string | Date): string | null => {
    const raw = value instanceof Date ? value.toISOString() : value.trim()
    if (raw === '') return null
    const date = new Date(HAS_TIMEZONE.test(raw) ? raw : `${raw.replace(' ', 'T')}+04:00`)
    return Number.isNaN(date.getTime()) ? null : date.toISOString()
}
